export default __webpack_public_path__ + "static/media/filter.03fb7d9b.svg";